import React from "react";
import CasestudyTemplate, {
  Header,
  Introduction,
  Challenge,
  Body,
} from "../../../../templates/casestudyTemplate";
import Section from "../../../../components/section";
import Gallery from "../../../../components/gallery";

export default function IndexPage() {
  return (
    <CasestudyTemplate id="extramed">
      <Header id="extramed" />
      <Introduction id="extramed">
        <p>
          ExtraMed is a 4th generation Patient Flow Management System, providing
          integrated patient flow from admission to discharge.
        </p>
        <p>
          Healthcare organisations benefit from patient safety improvements,
          time and cost efficiencies, and real-time operational insight that
          identifies bottlenecks and helps reduce patient length of stay.
        </p>
        <p>
          I had the opportunity to work with the ExtraMed team on the re-design
          of their product and to help shape their newest feature set through,
          research and usability testing.
        </p>
      </Introduction>
      <Challenge id="extramed">
        <p>
          The ExtraMed software is complicated and deals with complex medical
          data, unique to the patient in the bed. These patients need bespoke
          care and their medical experts need to clearly and quickly understand
          their condition.
        </p>
        <p>
          ExtraMed often replaces paper-based forms that nursing staff have used
          for years, so the software needs to be robust and intuitive. It also
          needs to run smoothly on a range of hardware, and cope with the NHS's
          ageing IT infrastructure.
        </p>
      </Challenge>
      <Body id="extramed">
        <Section>
          <p>
            When Hospedia bought the software company ExtraMed, I was asked to
            work with key stakeholders, and project sponsors to explore a
            redesign of the ExtraMed user interface and the overall user
            experience which had suffered from feature creep and no clear design
            direction.
          </p>
          <p>
            I led the redesign for ExtraMed across all platforms including
            mobile, tablet, desktop, and bespoke bedside terminals.
          </p>

          <h3>Ideas and iterations</h3>

          <p>
            I worked with the CEO as well as the product owner and UX consultant
            to explore pain points of using the existing software, proposing
            concepts of solutions that addressed the issues and developed a
            responsive design/framework for future features
          </p>

          <h3>Prototyping</h3>

          <p>
            I produced a range of prototypes that further explored concepts and
            interactions, from simple image based InVision prototypes to
            animated interactions and high fidelity HTML prototypes.
          </p>

          <h3>UX testing</h3>

          <p>
            I produced material to assist with UX testing sessions. The results
            of these sessions were used to inform further design iterations and
            to ensure the product was moving in the right direction.
          </p>

          <h3>Specifications and guidelines</h3>

          <p>
            As features were completed I liaised with development teams to
            ensure the final product satisfied the design specifications and
            guidlines I had created.
          </p>
        </Section>

        <Gallery
          id={"extramed"}
          images={[
            {
              source: "extramed1.png",
              alt: "",
            },
            {
              source: "extramed2.png",
              alt: "",
            },
            {
              source: "extramed3.png",
              alt: "",
            },
            {
              source: "extramed4.png",
              alt: "",
            },
          ]}
          options={{ grid: 2, width: "full", includeBackground: true }}
        />
      </Body>
    </CasestudyTemplate>
  );
}
